/**
 * Resolve Stripe Pricing Table ID by billing currency.
 * Public signup always embeds Pricing Table; currency comes from country capabilities.
 */

/**
 * @param {string} currency
 * @returns {string} Uppercase ISO currency or empty
 */
function normalizeBillingCurrency(currency) {
  return String(currency || "")
    .trim()
    .toUpperCase();
}

/**
 * @param {string} currency
 * @param {Record<string, unknown>} [config]
 * @returns {string} pricing-table-id or empty when not configured
 */
export function pricingTableIdForCurrency(currency, config = window.CONFIG) {
  const code = normalizeBillingCurrency(currency) || "BRL";
  const byCurrency = config?.STRIPE_PRICING_TABLE_IDS_BY_CURRENCY;
  if (byCurrency && typeof byCurrency === "object") {
    const direct = String(byCurrency[code] || "").trim();
    if (direct) return direct;
  }

  // Legacy single-ID config (BRL-only era).
  const legacy = String(config?.STRIPE_PRICING_TABLE_ID || "").trim();
  if (code === "BRL" && legacy) return legacy;

  if (typeof window !== "undefined" && window.Logger?.warn) {
    window.Logger.warn(
      `No Stripe Pricing Table configured for currency ${code}; signup plan embed skipped.`
    );
  }
  return "";
}
